import Chat from "./Chat";
import { useStartChat } from "./useStartChat";

export default function ChatAutoStart({
  proposal_id,
  purpose,
  searchType,
  context,
  docIds,
  ...props
}) {
  const { data: chatData, isLoading: isChatLoading } = useStartChat({
    searchType,
    proposal_id,
    purpose,
    docIds,
  });

  return (
    <Chat
      proposal_id={proposal_id}
      purpose={purpose}
      searchType={searchType}
      context={context}
      chatData={chatData}
      isChatLoading={isChatLoading}
      {...props}
    />
  );
}
